import { useState, useEffect } from 'react';
import { getSettings, updateSetting } from '../../../services/settings';
import Toast from '../../../components/Common/Toast';

const IntegrationSettings = () => {
  const [settings, setSettings] = useState([]);
  const [editing, setEditing] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [toast, setToast] = useState(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await getSettings();
      const integrationKeys = ['mpesa_consumer_key', 'mpesa_consumer_secret', 'firebase_credentials', 'smtp_host', 'twilio_sid'];
      setSettings(data.filter(s => integrationKeys.includes(s.key)));
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to load integration settings' });
    }
  };

  const handleSave = async (key) => {
    try {
      await updateSetting(key, tempValue);
      setToast({ type: 'success', message: 'Setting updated' });
      setEditing(null);
      loadSettings();
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  return (
    <div>
      <h1>Integration Settings</h1>
      <p>Configure external service credentials (M-Pesa, Firebase, Email, SMS).</p>
      <table className="data-table">
        <thead>
          <tr><th>Key</th><th>Value</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {settings.map(setting => (
            <tr key={setting.key}>
              <td>{setting.key}</td>
              <td>
                {editing === setting.key ? (
                  <input value={tempValue} onChange={e => setTempValue(e.target.value)} autoFocus />
                ) : (
                  setting.value ? '••••••••' : 'Not set'
                )}
              </td>
              <td>
                {editing === setting.key ? (
                  <>
                    <button onClick={() => handleSave(setting.key)}>Save</button>
                    <button onClick={() => setEditing(null)}>Cancel</button>
                  </>
                ) : (
                  <button onClick={() => { setEditing(setting.key); setTempValue(setting.value); }}>Edit</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default IntegrationSettings;